import { render, staticRenderFns } from "./BARRA.vue?vue&type=template&id=7a3f4faa&"
import script from "./BARRA.vue?vue&type=script&lang=js&"
export * from "./BARRA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports